// -- other --
import {useState,useEffect} from "react";
import {Link} from "react-router-dom";
import {all_routes} from "../../../../router/all_routes";
import ImageWithBasePath from "../../../../../core/img";
import Table from "../../../../../core/dataTable/non-pager/index";
import {Toaster} from 'react-hot-toast';
import {Image_Format} from "biz9-image";
import FeatherIcon from "feather-icons-react";
import App_User_Status_Type_Edit_Modal from "./appUserStatusTypeEditModal";
import App_Edit_Modal from "./appEditModal";
// -- biz9 --
import {UrlQuery} from "biz9-react-utility";
import {Field,Message,Title,Type,Project_Table,Config} from "../../../../../constant";
import {App,Data,Dashboard,Event,Image,Style,Service_Industry,Template,Toast_Message,Storage,System,User} from "../../../../../project";
import {User_Table,User_Logic} from "biz9-user";
import {Data_Logic} from "biz9-data-app";
import {DateTime,Str,Log,Obj} from "biz9-utility";
import {Portal_Type,Portal_Field,Portal_Url,Portal_Value_Type,Portal_Table,Portal_Remote_Data,Portal_Remote_Store_Order} from "biz9-portal-app";
const Dashboard_User_App_Detail = () => {
    const query = UrlQuery();
    const [val_sub_page_title,setValSubPageTitle] = useState(Str.get_table_by_name(Portal_Table.APP));
    const [val_id,setValId] = useState(query.get('id'));
    const [val_app_id,setValAppID] = useState(query.get('id'));
    const [val_order_number,setValOrderNumber] = useState(query.get('order_number'));
    //
    const [val_app_url,setValAppUrl] = useState("");
    const [val_link_id,setValLinkID] = useState("");
    const [links,setLinks] = useState([]);
    const [link,setLink] = useState(Data_Logic.get(Portal_Table.LINK,0));
    //
    const [val_status_type,setValStatusType] = useState("new");
    const [val_user_status_type,setValUserStatusType] = useState("pending");
    //
    const [val_app_title,setValAppTitle] = useState("");
    const [val_edit_field,setValEditField] = useState("");
    const [app,setApp] = useState(Data_Logic.get(Portal_Table.APP,0));

    const [val_order_status_type,setValOrderStatusType] = useState("");
    const [order_sub_items,setOrderSubItems] = useState([]);

    //
    const [templates,setTemplates] = useState([]);
    const [cmsystems,setCmSystems] = useState([]);
    const [hostings,setHostings] = useState([]);
    const db_collection_columns = [
    {
title: "Title",
           dataIndex: "title",
           key: "title",
           render: (text: string, record: any) => (
                   <>
                   {record.title}
                   </>
                   ),
           sorter: true
    },
    {
title: "Count",
       dataIndex: "item_count",
       key: "item_count",
       render: (text: string, record: any) => (
               <>
               {record.item_count}
               </>
               ),
       sorter: true
    },
    ];
    const link_columns = [
    {
title: "Title",
           dataIndex: "title",
           key: "title",
           render: (text: string, record: any) => (
                   <h2 className="table-avatar d-flex align-items-center">
                   <Link  data-bs-toggle="modal" data-bs-target="#app_edit_modal"  to={"#"} className="text-dark">
                   {App.get_app_link_by_type(record.type).title}
                   </Link>
                   </h2>
                   ),
           sorter: true
    },
    {
title: "Url",
       dataIndex: "url",
       render: (text: string, record: any) => (
               <>
               <Link to={record.url} target='_blank' className="text-dark">
               {record.url}
               </Link>
               </>
               )
    },
    {
title: "Action",
       dataIndex: "action",
       render: (res: string, record: any) => (
               <>
               <div className="dropdown dropdown-action">
               <Link to="#" className="action-icon" data-bs-toggle="dropdown" aria-expanded="false">
               <FeatherIcon icon="more-vertical" />
               </Link>
               <div className="dropdown-menu dropdown-menu-right">
               <Link className="dropdown-item" to="#" >
               <FeatherIcon icon="trash" /> Delete
               </Link>
               </div>
               </div>
               </>
               ),
    },
    ];
    const hosting_columns = [
    {
title: "Title",
           dataIndex: "title",
           key: "title",
           render: (text: string, record: any) => (
                   <h2 className="table-avatar d-flex align-items-center">
                   <Link  data-bs-toggle="modal" data-bs-target="#link_edit_modal"  to={"#"} className="text-dark">
                   {record.title}
                   </Link>
                   </h2>
                   ),
           sorter: true
    },
    {
title: "Type",
       dataIndex: "type",
       key: "type",
       render: (text: string, record: any) => (
               <>
               {record.type}
               </>
               ),
       sorter: true
    },
    {
title: "Category",
       dataIndex: "category",
       key: "type",
       render: (text: string, record: any) => (
               <>
               {record.category}
               </>
               ),
       sorter: true
    },
    ];
    const template_columns = [
    {
title: "Title",
           dataIndex: "title",
           key: "title",
           render: (text: string, record: any) => (
                   <h2 className="table-avatar d-flex align-items-center">
                   <Link to="{}" data-bs-toggle="modal" className="text-dark">
                   {record.title}
                   </Link>
                   </h2>
                   ),
           sorter: true
    },
    {
title: "Type",
       dataIndex: "type",
       key: "type",
       render: (text: string, record: any) => (
               <>
               {record.type}
               </>
               ),
       sorter: true
    },
    {
title: "Category",
       dataIndex: "category",
       key: "type",
       render: (text: string, record: any) => (
               <>
               {record.category}
               </>
               ),
       sorter: (a, b) => true
    },
    ];
    const cms_columns = [
    {
title: "Title",
           dataIndex: "title",
           key: "title",
           render: (text: string, record: any) => (
                   <h2 className="table-avatar d-flex align-items-center">
                   <Link to="#"  data-bs-toggle="modal" className="text-dark">
                   {record.title}
                   </Link>
                   </h2>
                   ),
           sorter: true
    },
    {
title: "Type",
       dataIndex: "type",
       key: "type",
       render: (text: string, record: any) => (
               <>
               {record.type}
               </>
               ),
       sorter: true
    },
    {
title: "Category",
       dataIndex: "category",
       key: "type",
       render: (text: string, record: any) => (
               <>
               {record.category}
               </>
               ),
       sorter: true
    },
    ];
    useEffect(() => {
        Toast_Message.loading(Message.LOADING);
        if(!Str.check_is_null(val_app_id)){
            get_data();
        }
    },[val_app_id]);
    useEffect(() => {
            Toast_Message.loading(Message.LOADING);
            if(!Str.check_is_null(val_order_number)){
                get_data_order(val_order_number);
            }
    },[val_order_number]);
    async function get_data() {
        let option_foreign_product = Data_Logic.get_foreign(Portal_Value_Type.ITEMS,Portal_Table.PRODUCT,Portal_Field.ID,Field.PRODUCT_ID,{title:'templates'});
        let option_foreign_cms = Data_Logic.get_foreign(Portal_Value_Type.ITEMS,Portal_Table.PRODUCT,Portal_Field.ID,Field.CMS_ID,{title:'cms'});
        let option_foreign_hosting = Data_Logic.get_foreign(Portal_Value_Type.ITEMS,Portal_Table.PRODUCT,Portal_Field.ID,Field.HOSTING_ID,{title:'hosting'});
        let option_foreign_link = Data_Logic.get_foreign(Portal_Value_Type.ITEMS,Project_Table.LINK,Field.APP_ID,Portal_Field.ID,{title:'links'});
        const option = {foreigns:[option_foreign_product,option_foreign_cms,option_foreign_hosting,option_foreign_link]};
        const [response,data] = await Portal_Remote_Data.get(App.get_url(Portal_Url.DATA_GET),Project_Table.APP,val_app_id,option);
        bind_items(data);
        Toast_Message.dismiss();
    }
 async function get_data_order(val_order_number) {
        const option = {/*foreigns:[option_foreign_order]*/};
        const [response,data] = await Portal_Remote_Store_Order.get(App.get_url(Portal_Url.STORE_ORDER_GET),val_order_number);
        bind_order_items(data);
        Toast_Message.dismiss();
     }
    async function bind_order_items(data){
         // -- tempaltes --
        if(data.order){
            setTemplates(data.order.order_items[0] ? [data.order.order_items[0].parent] : []);
            if(data.order.order_items.length>0){
                if(data.order.order_items[0]){
                    if(data.order.order_items[0].order_sub_items.length > 0){
                        for(const order_sub_item of data.order.order_items[0].order_sub_items){
                            switch(order_sub_item.parent.type){
                                case Title.PRODUCT_APP_TYPE_HOSTING:
                                setHostings([...hostings, order_sub_item.parent]);
                                break;
                                case Title.PRODUCT_APP_TYPE_CONTENT_MANAGEMENT_SYTSTEM:
                                setCmSystems([...cmsystems, order_sub_item.parent]);
                                break;
                            }
                        }
                    }
                }
            }
        }
    }
    async function bind_items(data){
        // -- app --
        setApp(data);
        // -- system-status --
        setValStatusType(data[Type.STATUS_TYPE]);
        // -- user-status --
        setValUserStatusType(data[Type.USER_STATUS_TYPE]);
        // -- title --
        setValAppTitle(data[Portal_Type.TITLE]);
        // -- url --
        setValAppUrl(data[Type.URL]);
       // -- links --
        setLinks(data.links);
    };
    const updateAppUserStatus = (user_status) => {
        app.user_status_type = user_status;
        setApp(app);
        setValUserStatusType(user_status);
    };
    const updateAppStatus = (status) => {
        setValStatusType(status);
    };
    const updateApp = (val_edit_field,value) => {
        switch(val_edit_field){
            case Portal_Field.TITLE:
            setValAppTitle(value);
            app.title = value;
            setApp(app);
            break;
            case Field.URL:
            setValAppUrl(value);
            app.url = value;
            setApp(app);
            break;
        }
    };
   return (
            <>
            <Toaster />
            {/* Page Content */}
            <div className="page-wrapper">
            <div className="page-content content">
            <div className="row justify-content-center">
            <div className="col-xl-10">
            <div className="main-title mb-4">
            <h4>{val_sub_page_title}</h4>
            </div>
            <ul className="nav nav-tabs nav-tabs-bottom mb-4">
            <li className="nav-item">
            <Link to={all_routes.dashboard_user_app} className="nav-link" >
            {"<- Back"}
            </Link>
            </li>
            </ul>
    {/* CARD-APP-STATUS-START */}
    <div className="card profile-card">
        <div className="card-body">
        <div className="d-flex align-items-center gap-3 justify-content-between flex-wrap">
        <div className="d-flex align-items-center flex-shrink-0">
        <div className="ms-3">
        <Link to={all_routes.dashboard_user_profile_detail+"?user_id="+User.get().id} >
        <h6 className="mb-1 d-inline-flex flex-wrap align-items-center">
        {Title.LABEL_SYSTEM_STATUS_TYPE + " - " + App.get_app_status_type_by_type(val_status_type).label}
    </h6>
        </Link>
        </div>
        </div>
        <Link hidden={true}  id='link_status_edit'  data-bs-toggle="modal" data-bs-target="#user_status_type_edit_modal" to={"#"} className="btn btn-lg btn-dark">
        {Title.LABEL_EDIT}
    </Link>
        </div>
        </div>
        </div>
        {/* CARD-APP-STATUS-END */}
    {/* CARD-APP-USER-STATUS-START */}
    <div className="card profile-card">
        <div className="card-body">
        <div className="d-flex align-items-center gap-3 justify-content-between flex-wrap">
        <div className="d-flex align-items-center flex-shrink-0">
        <div className="ms-3">
        <Link to={all_routes.dashboard_user_profile_detail+"?user_id="+User.get().id} >
        <h6 className="mb-1 d-inline-flex flex-wrap align-items-center">
        {Title.LABEL_USER_STATUS_TYPE + " - " + App.get_app_user_status_type_by_type(val_user_status_type).label }
    </h6>
        </Link>
        </div>
        </div>
        <Link   data-bs-toggle="modal" data-bs-target="#user_status_type_edit_modal" to={"#"} className="btn btn-lg btn-dark">
        {Title.LABEL_EDIT}
    </Link>
        </div>
        </div>
        </div>
        {/* CARD-APP-USER-STATUS-END */}
    {/* CARD-APP-DETAILS-START */}
    <div className="card profile-details">
        <div className="card-header">
        <h5 style={{float:'left'}} className="mb-0">{Title.LABEL_DETAILS}</h5>
        <Link  style={{float:'right'}} data-bs-toggle="modal" data-bs-target="#app_edit_modal" to={"#"} className="btn btn-lg btn-dark">
        {Title.LABEL_EDIT}
    </Link>
        </div>
        <div className="card-body">
        <div className="row row-gap-3">
        <div className="col-md-4 col-sm-6">
        <h6>Title</h6>
        <p className="mb-0">{val_app_title}</p>
        </div>
        <div className="col-md-4 col-sm-6">
        <h6>Date & Time</h6>
        <p className="mb-0">{DateTime.get_date(app.date_create)}{" "}{DateTime.get_time(app.date_create)}</p>
        </div>
        <div className="col-md-4 col-sm-6">
        <h6>APP-ID</h6>
        <p className="mb-0">{app.app_id}</p>
        </div>
        <div className="col-md-4 col-sm-6">
        <h6>Url</h6>
        <p className="mb-0">{val_app_url}</p>
        </div>
        <div className="col-md-4 col-sm-6">
        <h6>ID</h6>
        <p className="mb-0">{app.id}</p>
        </div>
        <div className="col-md-4 col-sm-6">
        <h6>Type</h6>
        <p className="mb-0">{app.type}</p>
        </div>
        <div className="col-md-4 col-sm-6">
        <h6>Category</h6>
        <p className="mb-0">{app.category}</p>
        </div>
        <div className="col-md-4 col-sm-6">
        <h6>Blank</h6>
        <p className="mb-0">{""}</p>
        </div>
        <div className="col-md-4 col-sm-6">
        <h6>Blank</h6>
        <p className="mb-0">{''}</p>
        </div>
        </div>
        </div>
        </div>
        {/* CARD-APP-DETAILS-END */}
    {/* CARD TEMPLATE-START */}
    <div className="card profile-details">
        <div className="card-header">
        <h5 style={{float:'left'}} className="mb-0">Templates</h5>
        <Link hidden={true}  style={{float:'right'}} to={"#"} data-bs-toggle="modal" data-bs-target="#order_payment_edit_modal" className="btn btn-lg btn-dark mb-0">
        {Title.LABEL_ADD}
    </Link>
        </div>
        <div className="table-responsive custom-table">
        <Table allow_multiple={true} table={Portal_Table.BLANK} dataSource={templates} columns={template_columns} Selection={false} />
        </div>
        </div>
        {/* CARD TEMPLATE-END */}
    {/* CARD TEMPLATE-START */}
    <div className="card profile-details">
        <div className="card-header">
        <h5 style={{float:'left'}} className="mb-0">Content Management Systems</h5>
        <Link hidden={true} style={{float:'right'}} to={"#"} data-bs-toggle="modal" data-bs-target="#order_payment_edit_modal" className="btn btn-lg btn-dark mb-0">
        {Title.LABEL_ADD}
    </Link>
        </div>
        <div className="table-responsive custom-table">
        <Table allow_multiple={true} table={Portal_Table.BLANK} dataSource={cmsystems} columns={cms_columns} Selection={false} />
        </div>
        </div>
        {/* CARD TEMPLATE-END */}
    {/* CARD HOSTING-START */}
    <div className="card profile-details">
        <div className="card-header">
        <h5 style={{float:'left'}} className="mb-0">{Title.LABEL_HOSTING}</h5>
        <Link hidden={true} style={{float:'right'}} to={"#"} data-bs-toggle="modal" data-bs-target="#order_payment_edit_modal" className="btn btn-lg btn-dark mb-0">
        {Title.LABEL_ADD}
    </Link>
        </div>
        <div className="table-responsive custom-table">
        <Table allow_multiple={true} table={Portal_Table.BLANK} dataSource={hostings} columns={hosting_columns} Selection={false} />
        </div>
        </div>
        {/* CARD HOSTING-END */}
    {/* CARD LINKS-START */}
    <div className="card profile-details">
        <div className="card-header">
        <h5 style={{float:'left'}} className="mb-0">{Title.LABEL_LINKS}</h5>
        <Link hidden={true} style={{float:'right'}} to={"#"} data-bs-toggle="modal" data-bs-target="#user_status_type_edit_modal" className="btn btn-lg btn-dark mb-0">
        {Title.LABEL_ADD}
    </Link>
        </div>
        <div className="table-responsive custom-table">
        <Table allow_multiple={true} table={Portal_Table.LINK} dataSource={links} columns={link_columns} Selection={false} />
        </div>
        </div>
        {/* CARD LINKS-END */}
    <div className="table-footer">
        <div id="tablepage" />
        </div>
        </div>
        </div>
        </div>
        </div>
        {/* /Page Content */}
    <App_User_Status_Type_Edit_Modal app={app}  onUpdate={updateAppUserStatus} />
    <App_Edit_Modal app={app}  onUpdate={updateApp} />
        </>
        );
};
export default Dashboard_User_App_Detail;
